import React, { useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import Layout from './layouts/Layout';
import BZAPIService from './services/BZAPIService';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
// import 'react-datetime/css/react-datetime.css';
// import 'react-image-lightbox/style.css';

const App = () => {
  useEffect(() => {
    onLoad();
  }, []);

  async function onLoad() {
    try {
      const bzAuthToken = localStorage.getItem('bzAuthToken');

      if (bzAuthToken) {
        BZAPIService.apiClient.setHeader('Authorization', `Bearer ${bzAuthToken}`);
      }
    } catch (e) {
      console.log(e);
    }
  }
  return (
    <div>
      <Router basename={process.env.PUBLIC_URL}>
        <Layout />
      </Router>
      <ToastContainer
        position="bottom-left"
        closeOnClick
        closeButton={false}
        pauseOnFocusLoss={false}
        draggable={false}
        newestOnTop
        pauseOnHover={false}
        theme="dark"
      />
    </div>
  );
};

export default App;
